import {ActionTree, GetterTree, Module, MutationTree} from 'vuex';
import {RootState} from '../RootState';
import {settings} from '@/plugins/settings';
import {helpdeskAxios} from '@/plugins/helpdeskAxios';
import responseHandler from '@/plugins/errorHandling';

export interface ITicketType {
  id: number;
  name: string;
  created_at: string;
  updated_at: string;
}

interface TicketTypesState {
  types: ITicketType[];
  currentPage: number;
  lastPage: number;
  total: number;
  perPage: number;
  errors: any;
}

const state: TicketTypesState = {
  types: [],
  currentPage: 1,
  lastPage: 1,
  total: 0,
  perPage: 15,
  errors: {},
};

const getters: GetterTree<TicketTypesState, RootState> = {
  types:       (state) => state.types,
  currentPage: (state) => state.currentPage,
  lastPage:    (state) => state.lastPage,
  total:       (state) => state.total,
  perPage:     (state) => state.perPage,
};

const mutations: MutationTree<TicketTypesState> = {
  errors(state, payload: any) { state.errors = payload; },
  typesLoaded(state, payload: any) {
    // all=1 devuelve un array directo; paginado devuelve objeto con .data
    if (Array.isArray(payload)) {
      state.types = payload;
    } else {
      state.types       = payload.data;
      state.currentPage = payload.current_page;
      state.lastPage    = payload.last_page;
      state.total       = payload.total;
      state.perPage     = payload.per_page;
    }
  },
  typeCreated(_state, _payload: any) {},
  typeUpdated(state, payload: ITicketType) {
    const idx = state.types.findIndex(t => t.id === payload.id);
    if (idx !== -1) state.types.splice(idx, 1, payload);
  },
  typeDeleted(_state, _payload: any) {},
};

const actions: ActionTree<TicketTypesState, RootState> = {
  fetchTypes: ({commit}, params?: {page?: number; per_page?: number; all?: boolean; search?: string}) => {
    const query = new URLSearchParams();
    if (params && params.all)      query.set('all',      '1');
    if (params && params.page)     query.set('page',     String(params.page));
    if (params && params.per_page) query.set('per_page', String(params.per_page));
    if (params && params.search)   query.set('search',   params.search);
    const qs = query.toString() ? '?' + query.toString() : '';
    return responseHandler.handle(
      () => helpdeskAxios({url: settings.helpdeskEndpoint + 'v1/ticket-types' + qs, method: 'GET'}),
      commit, 'typesLoaded',
    );
  },
  createType: ({commit}, data: {name: string}) => responseHandler.handle(
    () => helpdeskAxios({url: settings.helpdeskEndpoint + 'v1/ticket-types', method: 'POST', data}),
    commit, 'typeCreated', null, false,
  ),
  updateType: ({commit}, {id, data}: {id: number; data: {name: string}}) => responseHandler.handle(
    () => helpdeskAxios({url: settings.helpdeskEndpoint + 'v1/ticket-types/' + id, method: 'PATCH', data}),
    commit, 'typeUpdated',
  ),
  deleteType: ({commit}, id: number) => responseHandler.handle(
    () => helpdeskAxios({url: settings.helpdeskEndpoint + 'v1/ticket-types/' + id, method: 'DELETE'}),
    commit, 'typeDeleted', null, false,
  ),
};

export const helpdeskTicketTypesModule: Module<TicketTypesState, RootState> = {
  namespaced: true, state, getters, mutations, actions,
};
